export const LISTE_DISPOSITIF_TYPE = {
  title: 'Liste des types de dispositif',
  breadcrumb: {
    racine: 'Accueil',
    parametrage: 'Paramétrage',
    liste: 'Liste type de dispositif',
  },
  actions: {
    add: 'Ajouter un type de dispositif',
    search: 'Rechercher',
    edit: 'Modifier',
    delete: 'Supprimer',
    archiver: 'Archiver',
  },
  tab: {
    libelle: 'Libellé',
    codification: 'Codification',
  },
  messagesSuccess: {
    successSupprimer: 'Le type de dispositif a été supprimé avec succès.',
    successArchiver: 'Le type de dispositif a été archivée.',
    successDesarchiver: 'Le type de dispositif a été désarchivée.',
  },
  archivage: {
    archiver: 'Etes-vous sûr de vouloir archiver ce type de dispositif ?',
    desarchiver: 'Etes-vous sûr de vouloir désarchiver ce type de dispositif ?',
  },
  desarchivage: 'Etes-vous sûr de vouloir archiver ce type de dispositif ?',
  suppression: 'Etes-vous sûr de vouloir supprimer ce type de dispositif ?',
  yes: 'Oui',
  no: 'Non',
};

export const ADD_DISPOSITIF_TYPE = {
  titleAdd: 'Ajouter un type de dispositif',
  titleEdit: 'Modifier un type de dispositif',
  actions: {
    cancel: 'Annuler',
  },
  error: {
    problemOccurred: 'Un problème est survenu',
  },
  informationDispositifType: {
    libelle: 'Libellé',
    codification: 'Codification',
  },
  success: {
    add: 'Le type de dispositif a été ajouté avec succès.',
    edit: 'Le type de dispositif a été modifié avec succès.',
  },
};
